import { render, staticRenderFns } from "./DriverBfixSelect.vue?vue&type=template&id=72ef628b&scoped=true"
import script from "./DriverBfixSelect.vue?vue&type=script&lang=ts"
export * from "./DriverBfixSelect.vue?vue&type=script&lang=ts"
import style0 from "./DriversSelect.scss?vue&type=style&index=0&id=72ef628b&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ef628b",
  null
  
)

export default component.exports